// AI Generated Component
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import { sortByKeys, safeClone } from '@client/app/shared/utils/object-utils';
import { FormPagePerformanceProfileComponent } from '@client/app/modules/page-performance/forms/profile/form-page-performance-profile.component';
import {
    AssignedProfilesRepoService,
} from '@client/app/services/api/page-performance/assigned-profile-repo/assigned-profiles-repo.service';
import { MonDialog } from '@client/app/modules/dialog-upgrade-wrapper/mon-dialog.service';
import { PageRepoService } from '@client/app/services/api/page-repo/page-repo.service';
import {
    FormPagePerformancePageService,
} from '@client/app/modules/page-performance/forms/page/form-page-performance-page.service';
import { MonModalService } from '@client/app/modules/modals/services/mon-modal/mon-modal.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { SmartScrollService } from '@client/app/plugins/scroll/smart-scroll.service';
import {
    PagePerformanceService,
} from '@client/app/modules/page-performance/services/page-performance/page-performance.service';
import { ToastService } from '@monsido/angular-shared-components';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import {
    PagePerformanceProfileObsService,
} from '@client/app/modules/page-performance/services/profile-obs/profile-obs.service';

@Component({
    selector: 'form-page-performance-page',
    standalone: false,
    template: `
        <form #form="ngForm"
              class="form-page-performance-page form-horizontal"
              (ngSubmit)="canSubmit(form) && submit()">
            <div class="mon-dialog-header">
                <div class="outer-t-smurf">
                    <page-header [header]="getHeaderText()" panelLeftClass="col-48 mt-1"></page-header>
                </div>
            </div>
            <div class="mon-dialog-body-with-footer">
                <div class="d-flex flex-wrap">
                    <div class="card panel-monsido-card p-3 m-3 flex-basis-pixel-699 flex-grow-1">
                        <div class="card-header">
                            <h2 class="font-weight-300 my-1" translate>
                                Page Details
                            </h2>
                        </div>
                        <div class="card-body">
                            <div class="form-group mb-8 mx-0">
                                <label class="col-form-label text-bold" for="page_performance_page_id" translate>
                                    Select Page to scan
                                </label>
                                <div role="button"
                                     (click)="!model.id && setPage(null)"
                                     [attr.aria-disabled]="model.id > 0"
                                     class="btn btn-border-radius btn-secondary flat d-flex py-2"
                                     [ngClass]="{'active cursor-not-allowed': model.id > 0}"
                                     *ngIf="model.page_id">
                                    <span aria-hidden="true"
                                          class="fas fa-2x fa-globe mr-2 text-link align-self-center"></span>
                                    <div class="flex-fill zero-width mt-1">
                                        <url-title class="inline-block text-left max-width text-ellipsis"
                                                   [title]="selectedPage.title"
                                                   [url]="selectedPage.url"
                                                   [active]="false">
                                        </url-title>
                                    </div>
                                    <button type="button"
                                            *ngIf="!model.id"
                                            [title]="'Remove Page' | translate"
                                            class="btn btn-border-radius btn-link ml-2 p-0 align-self-start">
                                        <span class="fas fa-times fa-lg" aria-hidden="true"></span>
                                        <span class="sr-only" translate>Remove Page</span>
                                    </button>
                                </div>
                                <div class="search-container" *ngIf="!model.page_id">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text" [attr.aria-label]="'Search' | translate">
                                                <span class="fas fa-search fa-2x" aria-hidden="true"></span>
                                            </span>
                                        </div>
                                        <span class="sr-only" id="searchLabel" translate>Search for pages</span>
                                        <input type="search"
                                               [placeholder]="'Search for Pages' | translate"
                                               id="page_performance_page_id"
                                               name="page_performance_page_id"
                                               aria-describedby="searchLabel"
                                               [(ngModel)]="search"
                                               (ngModelChange)="debounceSearch()"
                                               (focus)="showPagesListDropdown()"
                                               class="form-control form-control-lg"
                                               autocomplete="off">
                                    </div>
                                    <div class="pages-container mr-3"
                                         [ngClass]="{'loading': loadingPages || pages.length === 0}"
                                         *ngIf="openDropDown">
                                        <div class="row align-items-stretch max-height">
                                            <mon-spinner class="mx-auto" [loading]="loadingPages">
                                                <div class="col-48 d-flex">
                                                    <p class="text-center text-grey font-size-1-75 align-self-center max-width mt-1"
                                                       *ngIf="pages.length === 0" translate>
                                                        No pages were found
                                                    </p>
                                                    <table class="table table-fixed table-hover align-self-stretch max-width"
                                                           *ngIf="pages.length > 0">
                                                        <thead>
                                                        <tr>
                                                            <th>
                                                                <div class="sr-only" translate>Url & Title</div>
                                                            </th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr class="page-row" *ngFor="let page of pages">
                                                            <td class="text-ellipsis text-v-middle"
                                                                (click)="setPage(page)">
                                                                <div class="d-flex align-items-center">
                                                                    <span class="fas fa-2x fa-globe mr-2 text-link"></span>
                                                                    <url-title class="py-2"
                                                                               [title]="page.title"
                                                                               [url]="page.url"
                                                                               [active]="false">
                                                                    </url-title>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </mon-spinner>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group mb-8" *ngIf="frequencyOptions.length > 1">
                                <label class="col-form-label text-bold" translate>
                                    Scan frequency
                                </label>
                                <p class="disc-text" translate>How often the page is checked</p>
                                <div class="row justify-content-between">
                                    <div *ngFor="let frequency of frequencyOptions; trackBy: trackByIndex" class="col d-flex">
                                        <button class="btn btn-border-radius btn-secondary flat flex-fill py-2 mt-1 mb-1"
                                                [ngClass]="{'active': frequency.value === model.scan_frequency}"
                                                type="button"
                                                (click)="selectFrequency(frequency)">
                                            <span [ngClass]="['PAGE_PERFORMANCE', 'PAGE', 'FREQUENCY'] | monIcons" class="fa-3x mt-1"></span><br/>
                                            <span class="inline-block mt-1 mb-1">{{frequency.name}}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row mb-8">
                                <label class="col-form-label text-bold col" for="page_performance_profile_id" translate>
                                    Visitor profile
                                </label>
                                <div class="text-right mr-3">
                                    <button type="button"
                                            *ngIf="['customer_admin'] | role"
                                            class="btn btn-border-radius btn-secondary"
                                            (click)="openProfile()"
                                            translate>
                                        Add Profile
                                    </button>
                                </div>
                                <p class="col-48 disc-text" translate>Select profiles that match your most frequent
                                    users</p>
                                <div class="col-48">
                                    <angular-selector
                                            [required]="false"
                                            monId="page_performance_profile_id"
                                            labelAttr="name"
                                            [placeholder]="getProfilePlaceHolder()"
                                            [options]="availableProfiles"
                                            [removeButton]="true"
                                            [multiple]="false"
                                            [skipModel]="true"
                                            name="selectedProfile"
                                            (change)="setProfile($event.newValue)"
                                            viewItemTemplate="app/modules/page-performance/forms/page/templates/profile_template.html"
                                            dropdownItemTemplate="app/modules/page-performance/forms/page/templates/profile_template.html">
                                    </angular-selector>
                                    <p class="text-danger mt-2"
                                        *ngIf="!hasProfiles() && this.availableProfiles.length > 0"
                                        translate>
                                        Please add a Profile to your Page
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card panel-monsido-card p-3 m-3 flex-basis-pixel-400 flex-grow-1">
                        <div class="card-header d-flex align-items-center">
                            <h2 class="font-weight-300 my-1" translate>
                                Summary
                            </h2>
                        </div>
                        <div class="card-body">
                            <div class="summery-text">
                                <label class="col-form-label text-bold" for="page_performance_page_id"
                                       id="page_performance_page_url" translate>
                                    URL:
                                </label>
                                <p *ngIf="isPageSelected()">
                                    <a [href]="selectedPage.url" target="_blank" aria-describedby="linkOpensInNewTab" class="text-nowrap"
                                       [attr.aria-label]="selectedPage.url">
                                        <span class="far fa-external-link-alt mr-1" aria-hidden="true"></span><span>{{ selectedPage.url }}</span>
                                    </a>
                                </p>
                            </div>
                            <div class="summery-text">
                                <label class="col-form-label text-bold" for="page_performance_page_id" translate>
                                    Scan frequency:
                                </label>
                                <p>
                                    <span aria-hidden="true" class="fas fa-history"></span>
                                    {{getFrequency().name}}
                                </p>
                            </div>
                            <div class="summery-text">
                                <label class="col-form-label text-bold" for="page_performance_page_id" translate>
                                    Visitor profile:
                                </label>
                                <div *ngIf="!model.default_profile_id">
                                    <p translate>
                                        No visitor profile selected
                                    </p>
                                </div>
                                <div class="row">
                                    <div class="col-24 col-md-16 col-lg-24 mb-2"
                                         *ngFor="let profileId of model.profile_ids">
                                        <div class="card panel-monsido-card profile-container max-width max-height"
                                             [attr.id]="'visitor-profile-' + profileId">
                                            <span class="label label-dodger-blue profile-label"
                                                  *ngIf="model.default_profile_id === profileId"
                                                  translate>
                                                    Default
                                            </span>
                                            <div class="card-body py-2 px-1 flex-fill d-flex mt-2 ml-5">
                                                <ul class="list-unstyled mt-1 mr-auto text-left text-wrap">
                                                    <li class="p-1">
                                                        <strong class="text-grey ml-1">{{profileDict[profileId].name}}</strong>
                                                    </li>
                                                    <li class="p-1">
                                                        <span class="fas fa-map-marker-alt fa-fw text-grey mr-1"
                                                              aria-hidden="true"></span>
                                                        <span class="text-grey" translate>Measure from:</span>
                                                        <div class="profile-card-text-to-right">
                                                            <mon-flag-icon [flag]="profileDict[profileId].getCountryCode()"></mon-flag-icon>
                                                            <span class="pl-1 text-bold profile-card-text-to-left">{{profileDict[profileId].getCountry()}}: {{profileDict[profileId].getCity()}} </span>
                                                        </div>
                                                    </li>
                                                    <li class="p-1">
                                                        <span class="mr-1 fa-fw text-grey mr-1"
                                                              aria-hidden="true"
                                                              [ngClass]="{'fas fa-desktop':profileDict[profileId].device === 'desktop', 'fal fa-mobile': profileDict[profileId].device === 'mobile'}">
                                                        </span>
                                                        <span class="text-grey" translate>Device:</span>
                                                        <p class="my-0 text-bold profile-card-text-to-right">{{profileDict[profileId].getDeviceName()}}</p>
                                                    </li>
                                                    <li class="p-1">
                                                        <span class="fa-fw fas fa-broadcast-tower mr-1 text-grey"
                                                              aria-hidden="true"></span>
                                                        <span class="text-grey" translate>Network speed:</span>
                                                        <p class="my-0 text-bold profile-card-text-to-right">{{profileDict[profileId].getConnectionName()}}</p>
                                                    </li>
                                                </ul>
                                                <div class="align-self-start d-flex align-items-end flex-column">
                                                    <div class="px-2 dropdown" ngbDropdown>
                                                        <button [attr.aria-label]="'Profile Dropdown' | translate"
                                                             tabindex="0"
                                                             type="button"
                                                             [attr.aria-pressed]="false"
                                                             class="dropdown-toggle dropdown-button"
                                                             ngbDropdownToggle
                                                             [attr.aria-haspopup]="true"
                                                             [attr.aria-expanded]="true">
                                                            <span class="fas fa-ellipsis-v text-link cursor-pointer"></span>
                                                        </button>
                                                        <ul class="dropdown-menu dropdown-menu-right"
                                                            ngbDropdownMenu
                                                            role="menu"
                                                            [attr.aria-label]="'Profile Dropdown' | translate">
                                                            <li role="menuitem">
                                                                <a role="button" (click)="removeProfile(profileDict[profileId])">
                                                                    <span class="fa-fw fas fa-trash-alt inner-r-smurf" aria-hidden="true"></span>
                                                                    <span translate>Remove Profile</span>
                                                                </a>
                                                            </li>
                                                            <li class="dropdown-item"
                                                               role="menuitem"
                                                               [attr.aria-disabled]="model.default_profile_id === profileId">
                                                                <a role="button"
                                                                   [ngClass]="{'mon-disabled': model.default_profile_id === profileId}"
                                                                   (click)="model.default_profile_id = profileId">
                                                                    <span [ngClass]="['PAGE_PERFORMANCE', 'PROFILE', 'DEFAULT'] | monIcons" class="fa-fw inner-r-smurf  fas fa-home-lg" aria-hidden="true"></span>
                                                                    <span translate>Set as Default</span>
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <p class="text-danger"
                                   *ngIf="!hasValidDefaultProfile()"
                                   translate>
                                    Please add a Default Profile to your Page
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mon-dialog-footer text-right">
                <button class="btn btn-border-radius btn-secondary"
                        data-test="save-button"
                        [disabled]="!canSubmit(form)"
                        type="submit">
                    <span class="fa-spin fa-fw" [ngClass]="{'fas fa-spinner': saving}" aria-hidden="true"></span>
                    <span translate>
                        Save
                    </span>
                </button>
            </div>
        </form>
    `,
})
export class FormPagePerformancePageComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input() monDialogId?: string;
    @Input() page?: any;
    @Input() assignedProfile?: any;

    frequencyOptions: any[] = [];
    loading = false;
    loadingPages: any;
    pages: any[] = [];
    openDropDown = false;
    model: any = {};
    selectedPage: any = {};
    profiles: any[] = [];
    availableProfiles: any[] = [];
    profileDict: any = {};
    page_num = 1;
    currentTarget: any = null;
    observer: any = null;
    indexPage: any = null;
    search = '';
    saving = false;
    selectedProfile: any;
    linkOpensInNewTab = 'linkOpensInNewTab';

    private readonly PAGE_SIZE = 50;
    private readonly ROWS_OFFSET = 10;
    private debounceTimer: any;

    constructor (
        private assignedProfileRepoService: AssignedProfilesRepoService,
        private monDialog: MonDialog,
        private pageRepoService: PageRepoService,
        private formPagePerformancePageService: FormPagePerformancePageService,
        private monModalService: MonModalService,
        private translateService: TranslateService,
        private smartScroll: SmartScrollService,
        private pagePerformanceService: PagePerformanceService,
        private toastService: ToastService,
        private monEventsService: MonEventService,
        private pagePerformanceProfileObsService: PagePerformanceProfileObsService,
        private elementRef: ElementRef,
        private cdRef: ChangeDetectorRef,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    ngOnDestroy (): void {
        if (this.observer) {
            this.observer.disconnect();
        }
        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
        }
    }

    ngAfterViewInit (): void {
        this.getIndexPage().then(() => this.getPages());
    }

    activate (): void {
        this.frequencyOptions = this.formPagePerformancePageService.getFrequencyOptions();
        this.loading = false;
        this.loadingPages = false;
        this.pages = [];
        this.openDropDown = false;

        this.model = safeClone(this.assignedProfile || {});
        this.selectedPage = safeClone(this.model.page || this.page || {});
        this.model.profile_ids = this.model.profile_ids || [];
        this.model.page_id = this.selectedPage.id;
        this.profiles = [];
        this.availableProfiles = [];
        this.profileDict = {};
        this.page_num = 1;
        this.currentTarget = null;

        this.observer = null;
        this.indexPage = null;

        if (typeof this.model.scan_frequency !== 'number') {
            this.model.scan_frequency = this.formPagePerformancePageService.getDefaultFrequencyOption();
        }

        if (typeof this.model.default_profile_id !== 'number' && this.model.profile_ids.length > 0) {
            this.model.default_profile_id = this.model.profile_ids[0];
        }
        this.setupListeners();
    }

    trackByIndex (index: number): number {
        return index;
    }

    debounceSearch (): void {
        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
        }
        this.debounceTimer = setTimeout(() => {
            this.getPages();
        }, 400);
    }

    getNewPages (): Promise<any> {
        this.page_num += 1;

        const params = {
            page: this.page_num,
            page_size: this.PAGE_SIZE,
            search: this.search,
            type: 'html',
            has_performance: false,
        };

        return this.pageRepoService.getAll(params).then((data: any) => {
            this.pages = this.pages.concat(data);
            return Promise.resolve(data);
        });
    }

    resetObserver (): void {
        if (this.observer) {
            this.page_num = 1;
            this.observer.disconnect();
            this.observer = null;
        }
    }

    getPages (): void {
        setTimeout(() => {
            if (typeof this.search !== 'string' || this.search.length < 3) {
                this.pages = this.prependIndexPage([]);
            }

            this.resetObserver();

            const params = {
                page: this.page_num,
                page_size: this.PAGE_SIZE,
                search: this.search,
                type: 'html',
                has_performance: false,
            };
            this.loadingPages = true;
            this.pageRepoService.getAll(params).then(
                (pages: any) => {
                    this.pages = this.prependIndexPage(pages);
                    this.loadingPages = false;

                    setTimeout(() => {
                        if (this.pages.length >= this.PAGE_SIZE) {
                            const searchContainer = this.elementRef.nativeElement.querySelector('.search-container');
                            const targets = this.elementRef.nativeElement.querySelectorAll('.page-row');
                            this.currentTarget = targets[targets.length - this.ROWS_OFFSET];
                            if (this.currentTarget) {
                                this.observer = new IntersectionObserver((entries) => {
                                    if (entries.some(entry => entry.isIntersecting)) {
                                        this.getNewPages().then((newPages) => {
                                            this.observer.unobserve(this.currentTarget);
                                            if (newPages.length === this.PAGE_SIZE) {
                                                const updatedTargets = this.elementRef.nativeElement.querySelectorAll('.page-row');
                                                this.currentTarget = updatedTargets[updatedTargets.length - this.ROWS_OFFSET];
                                                this.observer.observe(this.currentTarget);
                                            } else {
                                                this.resetObserver();
                                            }
                                        });
                                    }
                                }, {
                                    root: searchContainer,
                                });

                                this.observer.observe(this.currentTarget);
                            }
                        }
                    });
                },
                () => {
                    this.pages = [];
                },
            );
        });
    }

    setPage (page: any): void {
        this.search = '';
        this.openDropDown = false;
        this.selectedPage = page;
        this.model.page_id = page ? page.id : undefined;
    }

    setProfile (profile: any): void {
        if (profile) {
            const profileIds = safeClone(this.model.profile_ids);
            profileIds.push(profile.id);
            this.model.profile_ids = profileIds;
            const profileId = this.availableProfiles.findIndex(availableProfile => availableProfile.id === profile.id);
            this.availableProfiles.splice(profileId, 1);
            this.setDefaultProfileId();
            this.goToElement('visitor-profile-' + profile.id);
            this.cdRef.markForCheck();
        }
    }

    removeProfile (profile: any): void {
        const index = this.model.profile_ids.indexOf(profile.id);
        if (index > -1) {
            const message = this.translateService.getString('Are you sure you want to remove the Profile <strong>[[profileName]]</strong>?', {
                profileName: profile.name,
            });
            this.monModalService.confirm(message).then(() => {
                this.model.profile_ids.splice(index, 1);
                this.availableProfiles.push(profile);
                this.availableProfiles = this.sortProfiles(this.availableProfiles);
                this.setDefaultProfileId();
            }, () => {});
        }
    }

    selectFrequency (frequency: any): void {
        this.model.scan_frequency = frequency.value;
    }

    canSubmit (formCtrl: any): boolean {
        return formCtrl?.valid && !this.saving && this.isPageSelected() && this.hasProfiles() && this.hasValidDefaultProfile();
    }

    submit (): void {
        this.loading = true;
        let promise: Promise<any>;
        const model = safeClone(this.model);
        model.page_id = this.selectedPage.id;

        if (this.model.id > 0) {
            promise = this.assignedProfileRepoService.update(model);
        } else {
            promise = this.assignedProfileRepoService.create(model);
        }
        promise.then(
            (assignedProfile: any) => {
                this.close(assignedProfile);
            },
            () => {
                this.loading = false;
            },
        );
    }

    getFrequency (): any {
        return this.frequencyOptions.find(option => option.value === this.model.scan_frequency);
    }

    isPageSelected (): boolean {
        return this.selectedPage ? !(Object.entries(this.selectedPage).length <= 1) : false;
    }

    getSelectedProfiles (): any[] {
        return this.profiles.filter((profile: any) => {
            return this.model.profile_ids.indexOf(profile.id) > -1;
        });
    }

    openProfile (profile?: any): void {
        if (this.getAvailableProfiles() > 0) {
            const params = {
                body: FormPagePerformanceProfileComponent,
                size: 'md',
                data: {
                    profile: profile,
                },
            };
            this.monEventsService.run(MON_EVENTS.LOAD_DIALOG, { params });
        } else {
            this.pagePerformanceService.getReachedMaximumProfileMessageDialog()
                .then(() => {
                    this.requestMoreProfiles();
                });
        }
    }

    getProfilePlaceHolder (): string {
        if (this.availableProfiles.length > 0) {
            return this.translateService.getString('Select a profile');
        }
        return this.translateService.getString('You have no available profiles');
    }

    hasProfiles (): boolean {
        return this.model.profile_ids.length > 0;
    }

    hasValidDefaultProfile (): boolean {
        return !this.hasProfiles() || !!this.profileDict[this.model.default_profile_id];
    }

    showPagesListDropdown (): void {
        this.openDropDown = true;
    }

    private prependIndexPage (pages: any): any {
        const result = safeClone(pages);
        result.total = pages.total;
        result.currentPage = pages.currentPage;
        result.pageHits = pages.pageHits;
        result.perPage = pages.perPage;

        if (!this.indexPage) {
            return result;
        }

        const shouldPrependIndexPage = (this.search === '') || (this.search !== '' && result.length > 0);
        if (!shouldPrependIndexPage) {
            return result;
        }

        const existedIndexPageIndex = result.findIndex(page => page.id === this.indexPage.id);
        if (existedIndexPageIndex !== -1) {
            result.splice(existedIndexPageIndex, 1);
            result.unshift(this.indexPage);
        }

        return result;
    }

    private async getIndexPage (): Promise<void> {
        const params = {
            page: 1,
            page_size: 1,
            sort_by: 'url',
            sort_dir: 'asc',
            has_performance: false,
        };

        const data = await this.pageRepoService.getAll(params);

        if (data?.length > 0) {
            const [maybeIndexPage] = data;
            try {
                const urlObj = new URL(maybeIndexPage.url);
                if (urlObj.pathname === '/') {
                    this.indexPage = maybeIndexPage;
                    this.pages = this.prependIndexPage(this.pages);
                }
            } catch (_e) {
                this.indexPage = null;
            }
        }
    }

    private close (value: any): void {
        this.monDialog.close(this.monDialogId, value);
    }

    private setupProfiles (profiles: any[]): void {
        this.profiles = this.sortProfiles(profiles);
        this.availableProfiles = profiles.filter((profile: any) => {
            return this.model.profile_ids.indexOf(profile.id) === -1;
        });
        this.profileDict = {};
        this.profiles.forEach((profile: any) => {
            this.profileDict[profile.id] = profile;
        });
        this.model.profile_ids = this.model.profile_ids.filter((profileId: any) => {
            return !!this.profileDict[profileId];
        });
    }

    private sortProfiles (profiles: any[]): any[] {
        return sortByKeys(profiles, ['id']);
    }

    private setDefaultProfileId (): void {
        if (this.model.profile_ids.length > 0) {
            if (this.model.profile_ids.indexOf(this.model.default_profile_id) === -1) {
                this.model.default_profile_id = this.model.profile_ids[0];
            }
        } else {
            this.model.default_profile_id = null;
        }
    }

    private requestMoreProfiles (): void {
        this.monEventsService.run('actionTrigger', { action: 'maximum-number-of-profiles-confirm-confirmed' });
        this.saving = true;
        this.pagePerformanceService.requestMoreProfiles(this.translateService.getString('Contact me about more performance profiles'))
            .then(() => {
                this.toastService.success(this.translateService.getString('Our team has been notified of your request. We will soon be in touch.'));
            }, () => {})
            .finally(() => {
                this.saving = false;
            });
    }

    private getAvailableProfiles (): number {
        return this.formPagePerformancePageService.getMaxProfileCount() - (this.profiles.length || 0);
    }

    private goToElement (elementId: string): void {
        setTimeout(() => {
            const container = document.querySelector('.mon-dialog-body-with-footer');
            if (!container) {
                return;
            }
            this.smartScroll.scrollTo(container, elementId, 120);
        });
    }

    getHeaderText (): string {
        if (this.assignedProfile && !isNaN(this.assignedProfile.id)) {
            return this.translateService.getString('Edit Performance Page');
        }
        return this.translateService.getString('New Performance Page');
    }

    private setupListeners (): void {
        this.pagePerformanceProfileObsService.profilesObs.subscribe((profiles: any) => {
            this.setupProfiles(profiles);
        });
    }

    getLoadingPromise (): Promise<any> {
        return this.loadingPages ? Promise.resolve(true) : Promise.resolve(false);
    }
}
